import { Glyphicon } from 'react-bootstrap';
import React from "react";
import { Field } from 'redux-form';

import 'react-widgets/dist/css/react-widgets.css';
import 'bootstrap/dist/css/bootstrap.css';
import { UnstiledDropdownListField, NumberField } from '../../common/Inputs';
import OrderItemTotal from './OrderItemTotal';

let EditItemRow = class extends React.Component {
    render() {
        const { item, fields, index, services, formName } = this.props;

        const selectedServiceIds = fields.getAll()
            .filter(i => i.Service !== undefined)
            .map(i => typeof (i.Service.Id) === 'undefined' ? i.ServiceId : i.Service.Id);
        const filteredServices = services.filter(s => !selectedServiceIds.some(i => i === s.Id));

        return (
            <div>
                <div className="row" style={{ paddingBottom: "10px", paddingRight: "15px", paddingLeft: "15px" }}>
                    <div className="col-md-5">
                        <Field name={`${item}.Service`} component={UnstiledDropdownListField} data={filteredServices}
                            valueField={`${item}.ServiceId`} textField='Name'
                        />
                    </div>
                    <div className="col-md-2">
                        <Field name={`${item}.Amount`} component={NumberField} min={1} type='number' />
                    </div>
                    <div className="col-md-3">
                        <OrderItemTotal services={services} index={index} formName={formName} />
                    </div>
                    <div className="col-md-2">
                        <Glyphicon
                            glyph='trash'
                            onClick={() => fields.remove(index)}
                            style={
                                {
                                    float: 'left',
                                    color: 'red',
                                    cursor: 'pointer',
                                    verticalAlign: 'center',
                                    marginTop: '10px'
                                }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default EditItemRow;


// WEBPACK FOOTER //
// ./src/components/orders/items/EditItemRow.jsx